import { Box } from "@mui/material";

import { Constants } from "../../../../config/constants";

import MainNotificationManager from "../../../../components/MainNotificationManager";
import MainText from "../../../../components/MainText";

export default function NotificationConfig() {
  return (
    <Box mt={3}>
      <MainText size="subtitle">Notificações</MainText>

      <Box mt={2}>
        <MainNotificationManager topicsToManage={Constants.publicTopics} />
      </Box>
    </Box>
  );
}
